import lazyComponent from 'lib/lazyLoad';

export const Substitutions = lazyComponent(() => import(/* webpackChunkName: "Substitutions" */'./Substitutions'));
